<template>
  <section class="approvalInfoModify">
    <section class="viewTitle">
      <viewTitle
        :title="
          `业务管理 / 审批跳过情况汇总 / 消息管理 / ${
            type === 'add' ? '新建消息' : '再次发送信息'
          }`
        "
        :showReturn="true"
      />
    </section>

    <div class="listAdmin">
      <el-form label-width="120px" style="width: 550px;">
        <el-form-item
          label="发送范围："
          :rules="[{ required: true, message: '' }]"
        >
          <div v-for="(itemList, index) in listSuperAdmin" :key="index">
            <span
              class="adminItem"
              v-for="(item, indexItem) in itemList"
              :key="indexItem"
            >
              <User
                :item="item"
                :key="index + indexItem"
                :type="index"
                @removeTag="removeTag(index, item.id)"
              />
            </span>
          </div>
          <div>
            <span type="text" @click="selectSuperAdmin" style="color: #409EFF;"
              >选择发送范围</span
            >
          </div>
        </el-form-item>
        <el-form-item
          label="消息类别："
          :rules="[{ required: true, message: '' }]"
        >
          <el-select
            class="ctl"
            v-model="params.class_id"
            placeholder="请选择消息类别"
            clearable
            style="width: 100%;"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="item in categoryOptions"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="消息标题："
          :rules="[{ required: true, message: '' }]"
        >
          <el-input
            v-model="params.title"
            placeholder="请输入消息标题"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="导入文件："
          :rules="[{ required: true, message: '' }]"
        >
          <el-upload
            class="avatar-uploader"
            ref="upload"
            :http-request="uploadFile"
            action=""
            :auto-upload="true"
            :show-file-list="false"
            :multiple="true"
            :file-list="fileList"
            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          >
            <span
              type="text"
              style="color: #409EFF;"
              v-if="params.file.file_name"
              >{{ params.file.file_name }}</span
            >
            <span type="text" style="color: #409EFF;" v-else>点击选择</span>
          </el-upload>
          <div>
            <!-- <el-table
              v-if="showTable"
              :max-height="tableMaxSize"
              style="width: 100%;"
              show-overflow-tooltip
              :data="tableData"
              header-cell-class-name="table-header-cell"
              header-row-class-name="table-header-row"
              cell-class-name="table-cell"
              :border="true"
            >
            </el-table> -->
            <table
              style="border-collapse: collapse;width: calc(100vw - 500px);"
            >
              <tr>
                <td
                  style="word-break: keep-all;border: 1px solid #eee;padding:4px 8px;font-weight: bold;"
                  v-for="(item, index) in excelCont.header"
                  :key="index"
                >
                  {{ item }}
                </td>
              </tr>
              <tr v-for="(item, index) in excelCont.items" :key="index">
                <td
                  style="word-break: keep-all;border: 1px solid #eee;padding:4px;word-wrap:break-word;word-break:break-all;line-height: 20px;"
                  v-for="(itemTd, indexi) in item"
                  :key="indexi"
                >
                  {{ itemTd }}
                </td>
              </tr>
            </table>
          </div>
        </el-form-item>
        <el-form-item label="定时发送时间">
          <template>
            <el-date-picker
              style="width:450px"
              v-model="params.publish_timing"
              type="datetime"
              clear-icon="el-icon-circle-close"
              placeholder="（可选）不选代表立即发送"
              format="yyyy-MM-dd HH:mm"
              value-format="timestamp"
              :default-value="defaultTime"
            ></el-date-picker>
          </template>
        </el-form-item>
      </el-form>
      <div class="mt30">
        <el-button type="primary" @click="onPre" size="small">
          扫码预览
        </el-button>
        <el-button type="primary" @click="onSubmit" size="small">
          {{ type === "edit" ? "再次发送" : "发送" }}
        </el-button>
        <template v-if="type === 'edit'">
          <el-button
            size="small"
            @click="
              $router.push({
                path: '/rhqy/service/approval/info'
              })
            "
          >
            取 消
          </el-button>
        </template>
      </div>
    </div>
    <Dept
      :model="deptListObj.model"
      :title="deptListObj.title"
      :visible="deptListObj.visible"
      :selected="deptListObj.pluginResult.select"
      :urlType="deptListObj.urlType"
      @confirm="deptListObjConfirm"
      @updateVisible="deptListObjUpdateVisible"
    />

    <el-dialog
      class="confirm-dialog"
      :visible.sync="qrCodeShow"
      width="30%"
      :show-close="false"
      title="扫描二维码预览"
      :close-on-click-modal="false"
    >
      <div style="display: flex;justify-content: center;">
        <div id="qrcode"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="qrCodeShow = false" size="small">
          <span>关 闭</span>
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      class="confirm-dialog"
      :visible.sync="dialogParams.show"
      width="30%"
      title="确认提醒"
      :close-on-click-modal="false"
    >
      <div>
        <span class="color67">确认要删除数据吗？删除后不可恢复！</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm" size="small">
          <span>确定</span>
        </el-button>
        <el-button @click="dialogParams.show = false" size="small">
          <span>取消</span>
        </el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import moment from "moment";
import viewTitle from "@/components/viewTitle";
import Dept from "@/components/qyDept/";
import User from "@/components/qyDept/user";
import QRCode from "qrcodejs2";
import mixinOrgUrl from "@/components/qyDept/mixinOrgUrl.js";

export default {
  data() {
    return {
      deptListObj: {
        title: "选择发送范围",
        model: "both",
        visible: false,
        pluginResult: {
          select: { org: [], group: [], user: [] }
        },
        numberShowPhone: false,
        urlType: "sysAdmin"
      },
      domain: "",
      appId: "",
      comId: "",
      listSuperAdmin: { org: [], group: [], user: [] },
      params: {
        class_id: "", // 分类记录id
        title: "", // 消息标题
        publish_timing: "", // 定时发送时间
        file: {}
      },
      dialogParams: {
        show: false,
        content: ""
      },
      categoryOptions: [],
      preDomCreat: false,
      preExcleDom: false,
      fileList: [],
      scanSrc: "",
      excelCont: {
        header: [],
        items: []
      }, // excel内容
      qrCodeShow: false,
      orgUrl: "",
      defaultTime: moment().format("YYYY-MM-DD HH:mm")
    };
  },

  components: {
    // pagi,
    viewTitle,
    Dept,
    User
  },

  mixins: [mixinOrgUrl],

  computed: {
    type() {
      return this.$route.query.type;
    },
    id() {
      return this.$route.query.id;
    }
  },

  mounted() {},

  async activated() {},

  async created() {
    this.orgUrl = await this.mixinOrgUrlSet("sysAdmin");
    this.getCategoryList();
    this.getDetail();
    this.getDomain();
  },

  methods: {
    deptListObjConfirm(obj) {
      for (let key in obj) {
        this.deptListObj.pluginResult.select[key] = obj[key];
      }
      this.setSuperAdminUser();
    },

    deptListObjUpdateVisible(val) {
      this.deptListObj.visible = val;
    },

    selectSuperAdmin() {
      this.deptListObj.visible = true;
    },

    setSuperAdminUser() {
      this.listSuperAdmin = this.deptListObj.pluginResult.select;
    },

    removeTag(key, reItem) {
      let delIndex = 0;
      this.deptListObj.pluginResult.select[key].forEach((item, index) => {
        if (reItem == item.id) {
          delIndex = index;
        }
      });
      this.deptListObj.pluginResult.select[key].splice(delIndex, 1);
    },

    // 获取类别列表
    async getCategoryList() {
      let dataObj = await this.$common.http({
        url: "/api/psummary/admin/list_class",
        data: {
          page: 1,
          page_size: 9999999
        }
      });
      let obj = dataObj.data.data;
      obj.items.forEach(item => {
        this.categoryOptions.push(item);
      });
    },

    // 确认删除
    confirm() {
      this.dialogParams.show = false;
      this.$common
        .http({
          url: "/api/psummary/admin/delete_summary",
          data: {
            id: this.id
          }
        })
        .then(() => {
          this.$common.pcToastSuccess("删除成功");
          setTimeout(() => {
            this.$router.history.go(-1);
          }, 1500);
        });
    },

    // 点击选择
    uploadFile(req) {
      console.log(req);
      this.scanSrc = window.URL.createObjectURL(req.file);
      const data = new FormData();
      data.append("file", req.file);
      this.$common
        .http({
          url: "/api/media/upload",
          file: data
        })
        .then(res => {
          console.log(res.data.data);
          this.params.file = res.data.data;
          // 读取excel的内容
          this.readExcel();
        });
    },

    // 读取excel的内容
    readExcel() {
      this.$common
        .http({
          url: "/api/psummary/admin/excel_content",
          data: {
            file: JSON.stringify(this.params.file)
          }
        })
        .then(res => {
          console.log(res.data.data);
          this.excelCont = res.data.data;
          this.$common.pcToastSuccess("上传成功");
        });
    },

    // 预览
    onPre() {
      // if (this.params.class_id.trim() === "") {
      //   this.$common.pcToastFail("请选择消息类别");
      //   return false;
      // }
      if (this.params.title.trim() === "") {
        this.$common.mbToastFail("请输入消息标题");
        return false;
      }
      this.$common
        .http({
          url: "/api/psummary/admin/generate_preview",
          data: {
            title: this.params.title,
            situation: JSON.stringify(this.excelCont.items)
          }
        })
        .then(res => {
          console.log(res.data.data);
          let obj = res.data.data;
          this.$common.pcToastSuccess("上传成功");
          this.qrCodeShow = true;
          let url = `${obj.preview_domain}/rhwx/index.html#/rhwxApprovalInfo?id=${obj.preview_key}&type=edit&com_id=${obj.com_id}&app_id=process_pass`;
          setTimeout(() => {
            document.getElementById("qrcode").innerHTML = "";
            new QRCode("qrcode", {
              text: url,
              width: 260,
              height: 260
            });
          }, 100);
        });
    },

    // 获取详情
    getDetail() {
      if (this.id) {
        this.$common
          .http({
            url: "/api/psummary/admin/detail_summary",
            data: {
              id: this.id
            }
          })
          .then(res => {
            console.log(res);
            let obj = res.data.data;
            this.params.title = obj.title;
            this.params.class_id = obj.class_id;
            this.params.publish_timing =
              Number(obj.publish_timing) > 0
                ? Number(obj.publish_timing) * 1000
                : "";
            this.params.file.file_name = obj.file_name;
            this.excelCont.items = obj.situation;
            for (let key in obj.situation[0]) {
              this.excelCont.header.push(key);
            }
            console.log(this.orgUrl.getInitData);
            this.$common
              .http({
                url: this.orgUrl.getInitData,
                data: {
                  depts: obj.dept_list,
                  users: obj.user_list,
                  tags: obj.group_list
                }
              })
              .then(res1 => {
                console.log(res1);
                let obj1 = res1.data.data;
                this.listSuperAdmin = {
                  org: obj1.depts,
                  group: obj1.tags,
                  user: obj1.users
                };
                this.deptListObj.pluginResult.select = {
                  org: obj1.depts || [],
                  group: obj1.tags || [],
                  user: obj1.users || []
                };
              });
          });
      }
    },

    async getDomain() {
      let dataObj = await this.$common.http({
        url: "/api/psummary/admin/list_summary",
        data: {
          keyword: "",
          class_id: "",
          page_size: 10,
          page: 1
        }
      });
      this.domain = dataObj.data.data.preview_domain;
      this.appId = dataObj.data.data.app_id;
      this.comId = dataObj.data.data.com_id;
    },

    // 提交
    onSubmit() {
      let user_list = [];
      this.listSuperAdmin.user.forEach(item => {
        user_list.push(item.id);
      });
      let dept_list = [];
      this.listSuperAdmin.org.forEach(item => {
        dept_list.push(item.id);
      });
      let group_list = [];
      // this.listSuperAdmin.group.forEach(item => {
      //   group_list.push(item.id);
      // });
      if (user_list.length === 0 && dept_list.length === 0) {
        this.$common.pcToastFail("请选择发送范围");
        return false;
      }
      if (this.params.class_id === "") {
        this.$common.pcToastFail("请选择消息类别");
        return false;
      }
      if (this.params.title.trim() === "") {
        this.$common.pcToastFail("请输入消息标题");
        return false;
      }
      if (JSON.stringify(this.params.file) === "{}") {
        this.$common.pcToastFail("请导入文件");
        return false;
      }
      if (
        this.params.publish_timing !== "" &&
        this.params.publish_timing / 1000 < moment().unix()
      ) {
        this.$common.pcToastFail("定时发送时间需大于当前时间");
        return false;
      }
      let url = "";
      // if (this.type === "edit") {
      //   url = "/api/psummary/admin/update_summary";
      // } else {
      url = "/api/psummary/admin/create_summary";
      // }
      let data = {
        title: this.params.title,
        class_id: this.params.class_id,
        user_list: JSON.stringify(user_list),
        dept_list: JSON.stringify(dept_list),
        group_list: JSON.stringify(group_list),
        publish_timing: this.params.publish_timing / 1000,
        situation: JSON.stringify(this.excelCont.items),
        file_name: this.params.file.file_name
      };
      if (this.type === "edit") {
        data.id = this.id;
      }
      console.log(url, data);
      this.$common
        .http({
          url: url,
          data: data
        })
        .then(res => {
          this.$common.pcToastSuccess(
            `${this.type === "edit" ? "再次发送成功" : "发送成功"}`
          );
          setTimeout(() => {
            if (this.type === "edit") {
              this.$router.push({
                path: "/rhqy/service/approval/info/detail",
                query: {
                  id: res.data.data.id,
                  domain: this.domain,
                  comId: this.comId,
                  appId: this.appId
                }
              });
            } else {
              this.$router.history.go(-1);
            }
          }, 1500);
        });
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.approvalInfoModify {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // padding: 16px;
  overflow: auto;
  .viewTitle {
    width: 100%;
    box-sizing: border-box;
    padding: 16px 16px 0 16px;
    height: 59px;
    border-bottom: 1px solid #e4e4e4;
  }
  .listAdmin {
    padding: 16px;
    > p {
      margin: 0;
    }
  }
  .adminItem {
    margin-right: 10px;
  }
  .el-form-item {
    margin-bottom: 12px;
  }
}
</style>
